import React, {
  type PropsWithChildren,
  useEffect,
  useRef,
  useState,
} from 'react';
import cx from 'classnames';

import './InputFieldErrorMessage.scss';

interface InputFieldErrorMessageProps {
  className?: string;
  dataTestId?: string;
  isInfo?: boolean;
  positionRelative?: boolean;
}

const InputFieldErrorMessage: React.FC<
  PropsWithChildren<InputFieldErrorMessageProps>
> = ({ children, className, dataTestId, isInfo, positionRelative }) => {
  const errorRef = useRef<HTMLElement>(null);
  const [lineCount, setLineCount] = useState(0);

  useEffect(() => {
    if (!children) return;

    const calculateLines = () => {
      if (!errorRef.current) return;
      const { clientHeight } = errorRef.current;
      const { lineHeight } = window.getComputedStyle(errorRef.current);
      setLineCount(Math.floor(clientHeight / parseInt(lineHeight, 10)));
    };

    calculateLines();
    window.addEventListener('resize', calculateLines);

    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('resize', calculateLines);
    };
  }, [children]);

  return (
    <small
      data-testid={dataTestId || 'text-field-error-test-id'}
      className={cx(
        'form__form-group-error error-message',
        {
          'validation invalid-feedback': !isInfo,
          'position-relative': lineCount > 1 || positionRelative,
          'info-message': isInfo,
        },
        className
      )}
      ref={errorRef}
    >
      {children}
    </small>
  );
};

export default InputFieldErrorMessage;
